import { render, staticRenderFns } from "./ComprobantePago.vue?vue&type=template&id=3ab25838&scoped=true"
import script from "./ComprobantePago.vue?vue&type=script&lang=js"
export * from "./ComprobantePago.vue?vue&type=script&lang=js"
import style0 from "./ComprobantePago.vue?vue&type=style&index=0&id=3ab25838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab25838",
  null
  
)

export default component.exports